/**
 * Popup Form CTA functionality.
 *
 * @package ppd
 * @since   1.0.0
 */

/**
 * Import dependencies.
 */
import $ from 'jquery';

function initPopupFormCTAs() {
	const pfCTAButtonSelector = `.popup-form-cta__button`;
	const pfCTAButtons = document.querySelectorAll(pfCTAButtonSelector);
	const pfCTACloserSelectors = `.popup-form-cta__close, .popup-form-cta__overlay`;


	$(pfCTAButtons).each(
		function() {
		$(this).on('click', function () {
			$(this).parents(`.alignwide`).siblings(`.popup-form-cta__popup`).toggleClass('visible');
			$('html, body').toggleClass('noscroll');
		});
		}
	);

	$(pfCTACloserSelectors).each(
		function() {
			$(this).on('click', function() {
				$(`.popup-form-cta__popup`).toggleClass('visible');
				$('html, body').toggleClass('noscroll');
			});
		}
	);
}

// To prevent errors on other pages, only run this script on the insights hub page.
if (document.querySelector(".em-popup-form-cta")) {
	document.addEventListener('DOMContentLoaded', initPopupFormCTAs);
}
